import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { useBoardName } from "../../../../../reactQuery/boards";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { getResponseData } from "../../../../../reactQuery/response";

export function useBoardFeedsState() {
  const { id: boardId } = useBoardIdByKey();
  const { boardName: boardQuery, isLoading } = useBoardName(boardId);
  const [loading, setLoading] = useState(false);
  const [milestone] = useCustomSearchParams("milestone");
  const isMobile = useResponsive("down", "md");
  const { cardId: routeCardId } = useParams();

  const board = getResponseData(boardQuery);
  const isMilestoneView = milestone !== null;
  const normalizedCardId = useMemo(
    () => routeCardId?.split("-")[1] ?? null,
    [routeCardId]
  );
  const marginTopClass = useMemo(() => {
    if (isMobile) {
      return "mt-0";
    }

    return isMilestoneView ? "mt-185" : "mt-115";
  }, [isMilestoneView, isMobile]);

  return {
    board,
    boardHeaderData: { data: { responseData: board } },
    boardId,
    cardId: normalizedCardId,
    isMilestoneView,
    isLoading,
    loading,
    marginTopClass,
    ownerId: board?.owner_user_id ?? null,
    setLoading,
    workflowId: board?.workflow_id ?? null,
  };
}
